import { buttonVariants, cn, Container, Section } from '@resolute/ui';
import { Link } from 'react-router-dom';


import { Reveal } from '@/components/motion/reveal';
import { PageHero } from '@/components/page-hero';
import { Seo } from '@/lib/seo';

export default function ReraDisclosuresPage() {
  return (
    <>
      <Seo
        title="RERA Disclosures"
        description="RERA registration disclosures for Resolute Property Solutions listings — consolidated developer and project data."
        path="/rera"
        noindex
      />

      <PageHero
        eyebrow="Legal"
        title="RERA disclosures."
        titleLine2="On record, in the open."
        description="Every listing carries its RERA registration number and documents. A consolidated, searchable disclosures directory is on our roadmap."
      />

      <Section>
        <Container className="max-w-5xl">
          <Reveal className="rounded-lg border border-border bg-muted/30 p-8 text-center text-muted-foreground">
            <p className="text-sm">
              The consolidated RERA directory is not live yet. For a listing&apos;s actual RERA
              detail, open that property page directly.
            </p>
          </Reveal>

          <Reveal delay={0.12} className="mt-8 flex flex-wrap gap-3">
            <Link to="/search?verified=true" className={cn(buttonVariants({ variant: 'primary' }))}>
              View verified listings
            </Link>
            <Link to="/" className={cn(buttonVariants({ variant: 'outline' }))}>
              Back to home
            </Link>
          </Reveal>
        </Container>
      </Section>
    </>
  );
}
